// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Variables */
header.nav-small {
  min-height: 120px;
  line-height: 120px/2;
}
@media (max-width: 667.98px) {
  header.nav-small img {
    margin: 10px 0;
    width: 50%;
    text-align: center;
  }
}
@media (max-width: 4000px) and (min-width: 668px) {
  header.nav-small img {
    margin-top: 15px;
    width: 100%;
    text-align: left;
    margin-bottom: 15px;
  }
}
header.nav-small ul.navbar-nav {
  line-height: 20px;
}
header.nav-small ul.navbar-nav .first-link {
  border-right: 1px solid #B1B1B1;
  padding-right: 20px;
}
header.nav-small ul.navbar-nav .second-link {
  padding-left: 20px;
}
/*# sourceMappingURL=nav-small.component.css.map */`, "",{"version":3,"sources":["webpack://./src/app/layout/nav-small/nav-small.component.less","webpack://./nav-small.component.less"],"names":[],"mappings":"AAAA,cAAc;ACEd;EACE,iBAAA;EACA,oBAAA;ADAF;ACGI;EAAA;IACE,cAAA;IACA,UAAA;IACA,kBAAA;EDAJ;AACF;ACEI;EAAA;IACE,gBAAA;IACA,WAAA;IACA,gBAAA;IACA,mBAAA;EDCJ;AACF;ACjBA;EAoBI,iBAAA;ADAJ;ACpBA;EAsBM,+BAAA;EACA,mBAAA;ADCN;ACxBA;EA0BM,kBAAA;ADCN;AACA,kDAAkD","sourcesContent":["/* Variables */\nheader.nav-small {\n  min-height: 120px;\n  line-height: 120px/2;\n}\n@media (max-width: 667.98px) {\n  header.nav-small img {\n    margin: 10px 0;\n    width: 50%;\n    text-align: center;\n  }\n}\n@media (max-width: 4000px) and (min-width: 668px) {\n  header.nav-small img {\n    margin-top: 15px;\n    width: 100%;\n    text-align: left;\n    margin-bottom: 15px;\n  }\n}\nheader.nav-small ul.navbar-nav {\n  line-height: 20px;\n}\nheader.nav-small ul.navbar-nav .first-link {\n  border-right: 1px solid #B1B1B1;\n  padding-right: 20px;\n}\nheader.nav-small ul.navbar-nav .second-link {\n  padding-left: 20px;\n}\n/*# sourceMappingURL=nav-small.component.css.map */","@import '../../../assets/css/constant.less';\n\nheader.nav-small {\n  min-height: @header-height;\n  line-height: @header-height/2;\n\n  img {\n    @media (max-width: 667.98px) {\n      margin: 10px 0;\n      width: 50%;\n      text-align: center;\n    }\n\n    @media (max-width: 4000px) and (min-width: 668px) {\n      margin-top: 15px;\n      width: 100%;\n      text-align: left;\n      margin-bottom: 15px;\n    }\n  }\n\n  ul.navbar-nav{\n    line-height: 20px;\n    .first-link{\n      border-right: 1px solid @textLight;\n      padding-right: 20px;\n    }\n    .second-link{\n      padding-left: 20px;\n    }\n  }\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
